module.exports = __webpack_public_path__ + "img/pix-logo.5f75b1d7.png";